import { render, staticRenderFns } from "./ui-rich-color-choicer.vue?vue&type=template&id=0dfa33e4&scoped=true&"
import script from "./ui-rich-color-choicer.vue?vue&type=script&lang=js&"
export * from "./ui-rich-color-choicer.vue?vue&type=script&lang=js&"
import style0 from "./ui-rich-color-choicer.vue?vue&type=style&index=0&id=0dfa33e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfa33e4",
  null
  
)

export default component.exports